import { API_BASE_URL } from './constants';

const defaultHeaders = { 'Content-Type': 'application/json' };

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: options.body ? { ...defaultHeaders, ...(options.headers || {}) } : options.headers,
    credentials: 'include',
    ...options
  });

  if (!response.ok) {
    let errorBody;
    try {
      errorBody = await response.json();
    } catch (_) {
      errorBody = { message: response.statusText };
    }
    const error = new Error(errorBody.message || 'Request failed');
    error.status = response.status;
    error.body = errorBody;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const data = await response.json();
  return data;
}

export async function fetchCatalog(slug) {
  const json = await request(`/catalogs/${slug}`);
  return json?.data;
}

export async function fetchCatalogProducts(slug) {
  const json = await request(`/catalogs/${slug}/products`);
  return json?.data || [];
}

export async function fetchProduct(slug) {
  const json = await request(`/products/${slug}`);
  return json?.data;
}

async function postCart(body) {
  const json = await request('/cart', {
    method: 'POST',
    body: JSON.stringify(body || {})
  });
  return json?.data;
}

export async function createCart(token) {
  return postCart(token ? { token } : {});
}

export async function getCart(token) {
  const json = await request(`/cart/${token}`);
  return json?.data;
}

export async function ensureCart(token) {
  if (token) {
    try {
      const cart = await getCart(token);
      return { cart, token };
    } catch (error) {
      if (error.status !== 404) {
        throw error;
      }
    }
  }

  const cart = await createCart();
  return { cart, token: cart.token };
}

export async function addCartItem(token, payload) {
  const json = await request(`/cart/${token}/items`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
  return json?.data;
}

export async function updateCartItem(token, itemId, payload) {
  const json = await request(`/cart/${token}/items/${itemId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload)
  });
  return json?.data;
}

export async function deleteCartItem(token, itemId) {
  await request(`/cart/${token}/items/${itemId}`, {
    method: 'DELETE'
  });
}

export async function getPaypalConfig() {
  const json = await request('/paypal/config');
  return json?.data;
}

export async function createPaypalOrder(cartToken) {
  const json = await request('/paypal/orders', {
    method: 'POST',
    body: JSON.stringify({ cart_token: cartToken })
  });
  return json?.data;
}

export async function capturePaypalOrder(orderId, cartToken) {
  const json = await request(`/paypal/orders/${orderId}/capture`, {
    method: 'POST',
    body: JSON.stringify({ cart_token: cartToken })
  });
  return json?.data;
}
